// Set version number and date in the environment.store.ts file

export const environment = {
  production: false,
  baseUrl: '',
  context: 'dev',
};
